import React, { memo, useCallback, useEffect, useRef, useState } from "react";

const CommentCell = memo(({ comment }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 });
  const cellRef = useRef(null);
  const tooltipRef = useRef(null);
  
  const truncatedComment = comment.length > 50 ? `${comment.substring(0, 50)}...` : comment;
  const shouldShowTooltip = comment.length > 50;

  const handleMouseEnter = useCallback((e) => {
    if (!shouldShowTooltip) return;
    
    const rect = cellRef.current.getBoundingClientRect();
    setTooltipPosition({
      top: rect.bottom + 5,
      left: rect.left
    });
    setShowTooltip(true);
  }, [shouldShowTooltip]);

  const handleMouseLeave = useCallback(() => {
    setShowTooltip(false);
  }, []);

  const updateTooltipPosition = useCallback(() => {
    if (!showTooltip || !tooltipRef.current || !cellRef.current) return;
    
    const tooltip = tooltipRef.current;
    const rect = tooltip.getBoundingClientRect();
    const cellRect = cellRef.current.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    
    let newPosition = {
      top: cellRect.bottom + 5,
      left: cellRect.left
    };
    
    if (rect.right > viewportWidth - 10) {
      newPosition.left = viewportWidth - rect.width - 10;
    }
    
    if (rect.bottom > viewportHeight - 10) {
      newPosition.top = cellRect.top - rect.height - 5;
    }
    
    setTooltipPosition(newPosition);
  }, [showTooltip]);

  useEffect(() => {
    updateTooltipPosition();
  }, [updateTooltipPosition]);

  useEffect(() => {
    const handleScroll = () => showTooltip && setShowTooltip(false);
    
    if (showTooltip) {
      window.addEventListener('scroll', handleScroll, { passive: true });
      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, [showTooltip]);

  return (
    <>
      <div
        ref={cellRef}
        className={`truncate ${shouldShowTooltip ? 'cursor-help' : ''}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        title={shouldShowTooltip ? '' : comment}
      >
        {truncatedComment}
      </div>
      
      {showTooltip && (
        <div
          ref={tooltipRef}
          className="fixed z-50 bg-white border border-gray-300 rounded-md shadow-lg p-3 max-w-sm"
          style={tooltipPosition}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={handleMouseLeave}
        >
          <div className="text-sm text-gray-800 leading-relaxed">
            {comment}
          </div>
        </div>
      )}
    </>
  );
});

export default CommentCell;